import React from "react";
import { Pie } from "@ant-design/plots";
import { useSelector } from "react-redux";

const DashboardAreasPie = () => {
  const { areasTurnOver } = useSelector((state) => state.areasReducer);

  const data = [];
  for (let i = 0; i < areasTurnOver?.length; i++) {
    const value = parseFloat(areasTurnOver[i].total.toFixed(2));

    if (value !== 0) {
      data.push({
        type: areasTurnOver[i].name,
        value,
      });
    }
  }

  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    tooltip: {
      formatter: (datum) => {
        return { name: datum.type, value: datum.value.toFixed(2) };
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
    color: [
      "#003f5c",
      "#2f4b7c",
      "#665191",
      "#a05195",
      "#d45087",
      "#f95d6a",
      "#ff7c43",
      "#ffa600",
    ],
  };

  const isMobile = window.innerWidth > 850;

  if (isMobile) {
    config.legend = false;
  }

  return (
    <div className="areas-pie-chart-main-container">
      <Pie {...config} className="areas-pie-chart-secondary-container" />
    </div>
  );
};

export default DashboardAreasPie;
